<template>
  <div v-if="showPage403" class="animated fadeIn content-holder"> 
    <Page403></Page403>
  </div>
  <div v-else class="animated fadeIn content-holder">
    <b-card no-body>
      <b-card-header class="custom-header">
        <div><i class="icon-note"></i> Media Library {{ isMediaEditMode ? " - Edit" : " - New"}}</div>
        <b-button-group>       
          <b-button v-on:click="onReset()"><i class="fa fa-plus text-success"></i> New</b-button>
          <b-button v-on:click="post()"><i class="fa fa-save"></i> Save </b-button>
          <b-button v-on:click="routerBack()"><i class="fa fa-times text-danger"></i> Cancel</b-button>
        </b-button-group>
      </b-card-header>

      <b-card-body v-if="isLoading">
        <spinner></spinner> 
      </b-card-body>
      <b-card-body v-else>
        <b-row>
          <b-col md="9">
            <b-form v-on:submit.prevent="onSubmit" v-on:reset.prevent="onReset" novalidate>
              <b-row>
                <b-col md="12" v-show="!submitted">
                  <b-form-group id="selectfielsGroup2"
                    label-for="selectfiles">
                      <p>{{ isMediaEditMode ? "Browse file below to change current media file" : "Browse files"}}</p>
                      <div id="selectfiles" ref="selectfiles"></div>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-button v-on:click="test()" style="display:none"></b-button> 
              <b-button 
                :disabled="!isValid || submitted" 
                class="uploadBtn" v-on:click="uploadClick()" 
                v-show="isMediaEditMode==false&&filesToUpload.length&&submitted==false">
                Upload {{filesToUpload.length}} file{{(filesToUpload.length>1) ? 's':''}}
              </b-button>
              <b-button 
                :disabled="!isValid || submitted" 
                class="uploadBtn" v-on:click="uploadClick()" 
                v-show="isMediaEditMode==true&&fileDataToUpdate!=null&&submitted==false">
                Upload file
              </b-button> <br/>
              
              <label v-show="progressMsg" style="font-weight:bold">{{progressMsg}}</label><br/><br/>
              <b-progress :value="progressPercentage" v-show="showProgress" :variant="showProgressVariant" :animated="showProgressAnimated" class="mb-3"></b-progress>
              <p style="color: red" v-show="showProgressErrMsg">{{showProgressErrMsg}}</p>
              <span v-show="filesToUpload.length && !submitted" class="h5">
                  {{ isMediaEditMode ? "Edit" : "Add"}}  file(s)' details
              </span>
              <div v-for="file in filesToUpload" :key="file.id">
                <b-card
                  v-show="file.id"
                  header-tag="header"
                  footer-tag="footer">
                  <div slot="header">
                    <i class="fa fa-align-justify"></i> <strong> {{file.name}} </strong>
                    <div class="card-header-actions">
                      <b-progress class="mt-1" :id="`onprogress_${file.filename}`" v-show="file.onprogress">
                        <b-progress-bar style="width:50px" :value="100" variant="info" striped animated></b-progress-bar>
                      </b-progress>
                      <div v-if="!file.onprogress">
                        <i class="fa fa-check text-success" variant="primary" :id="`success_${file.filename}`" v-if="file.success"></i>
                        <i class="fa fa-times text-danger" variant="primary" :id="`error_${file.filename}`" v-if="file.error"></i>
                        <b-popover :target="`success_${file.filename}`" triggers="hover focus" v-if="file.success">
                          <div v-if="file.success" v-html="file.successDetails"></div>
                        </b-popover>
                        <b-popover :target="`error_${file.filename}`" triggers="hover focus" v-if="file.error">
                          <div v-if="file.error" v-html="file.errorDetails"></div>
                        </b-popover>  
                      </div>
                    </div>
                  </div>
                  <div>
                    <b-row>                 
                      <b-col md="4">
                        <!-- Firstname -->
                        <b-form-group id="titleInputGroup1"
                          label="Title"
                          label-for="title">
                          <b-form-input 
                            id="title"
                            type="text"
                            v-model.lazy.trim="file.name"
                            v-validate="{required:true, min:2}"
                            data-vv-as="title"
                            :class="{'form-control is-invalid': errors.first(`fileUpload_${file.id}_title`), 
                            'form-control is-valid': !errors.first(`fileUpload_${file.id}_title`)}"
                            :name="`fileUpload_${file.id}_title`"
                            placeholder=""
                            autofocus />
                          <b-form-invalid-feedback  id="input1LiveFeedback1" style="display:block;">
                            {{ errors.first(`fileUpload_${file.id}_title`) }}
                          </b-form-invalid-feedback>
                        </b-form-group>
                      </b-col>                  
                      <b-col md="4">
                        <!-- Last Name -->
                        <b-form-group id="aliasInputGroup2"
                          label="Alias"
                          label-for="alias">
                          <b-form-input :id="'alias_'+ file.id"
                            type="text"
                            v-model.lazy.trim="file.alias"
                            aria-describedby="input1LiveFeedback2"
                            placeholder=""
                            autocomplete='family-name'/>
                          <b-form-invalid-feedback id="input1LiveFeedback2">
                            This is a required field and must be at least 1 character
                          </b-form-invalid-feedback>
                        </b-form-group>
                      </b-col>
                      <b-col md="3">
                        <b-form-group id="selectfielsGroup2"
                          label="Preview"
                          label-for="preview">
                            <img v-if="!file.isVideo" class="selectFilePreivew" :src="file.preview_blob">
                            <!--<video v-if="file.isVideo" class="selectVideoPreivew" autoplay controls poster="" :src="file.preview_blob" preload="metadata">Your browser does not support the video element</video>-->

                        </b-form-group>
                      </b-col>
                    
                    </b-row>
                    
                    <b-row>
                      <b-col md="8">
                        <!-- Last Name -->
                        <b-form-group id="aliasInputGroup2"
                          label="Description"
                          label-for="description">
                            <b-form-textarea
                              :id="'description_'+ file.id"
                              v-model.lazy.trim="file.description"
                              placeholder="Enter something..."
                              rows="3"
                              >
                            </b-form-textarea>
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col>
                        <b-form-group>
                          <label id="published" class="d-block">Publish</label>
                          <c-switch class="mx-1" data-on="" data-off="" dataOn="" dataOff="" color="success" :checked="file.published" label v-model.lazy="file.published"/>
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row v-if="file.filepath">
                      <b-col md="8">
                        <!-- Last Name -->
                        <b-form-group id="filepath"
                          label="File Url"
                          label-for="file_url">
                          <b-form-input 
                            type="text"
                            readonly
                            v-model="file.filepath"
                            aria-describedby="input1LiveFeedback2"
                            placeholder=""
                            />
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </div>
                </b-card>
              </div>    
            </b-form>
            <br/>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import Vue from 'vue';
import { validationMixin } from "vuelidate";
import { required, minLength, email, sameAs, helpers } from "vuelidate/lib/validators";
import { Switch as cSwitch } from '@coreui/vue';
import { router } from '../../router/index';
import { mapState, mapActions } from 'vuex';
// import config from 'config';
const config = () => import('config')
import VueNotifications from 'vue-notifications';
import miniToastr from 'mini-toastr';
import { apigClient } from '@/shared/api';
import Page403 from "@/views/pages/Page403.vue";

const Spinner = () => import('../shared/Spinner');

const toastTypes = {
  success: 'success',
  error: 'error',
  info: 'info',
  warn: 'warn'
}
miniToastr.init({types: toastTypes})
function toast ({title, message, type, timeout, cb}) {
  return miniToastr[type](message, title, timeout, cb)
}
const options = {
  success: toast,
  error: toast,
  info: toast,
  warn: toast
}

Vue.use(VueNotifications, options);

export default {
  name: "MediaLibrary",
  components: {
    cSwitch,
    Spinner,
    Page403
  },
  data() {
    let newModePage = true;
    if(window.location.href.includes("/edit")){
      var media_id = localStorage.getItem('page_media_id');
      newModePage = false;
    }

    return {
      loginUserInfo: JSON.parse(localStorage.getItem('loginUserInfo')),
      permission: {
        permissionBaseName: null,
        permissionBaseNameCapabilities: null,
        capabilities: {
          View: false,
          Edit: false,
          Delete: false,
          Create: false,
        }
      },
      showPage403: false,
      newModePage: newModePage,
      endPoint: null,
      feedBack: 'secondary',
      submitted: false,
      media_id: media_id || null,
      isMediaEditMode: (media_id) ? true : false,
      disabled: true,
      isLoading: true,
      showProgress: false,
      showProgressVariant: 'info',
      showProgressAnimated: true,
      showProgressErrMsg: '',
      progressPercentage: 0,
      progressMsg: '',
      selectfilepreivew: '',
      filesToUpload : [],
      filesToUploadAndUpdate: [],
      editModeCurrentSavedFile: {
        fileS3Path: '',
        filename: '',
        storage_location: '',
        fileType: '',
        fileSize: '',
        name: '',
        alias: '',
        description: '',
        published: '',
        download_count: '',
        view_count: '',
      },
      fileDataToUpdate: null,
      uppy:'',
    }
  },
  
  mounted: function(){
    // permission stuffs
    this.getPermission();
    if(this.newModePage && !this.permission.capabilities.Create){
      this.showPage403 = true;
      return;
    } else if ( !this.newModePage && !this.permission.capabilities.Edit){
      this.showPage403 = true;
      return;
    }
    
    this.getEndPointBasedOnCustomerLocation();
    if ( this.media_id ){
      this.getMediaData(this.media_id);
      this.isLoading = false;
    } else {
      this.isLoading = false;
    }

    this.$nextTick(() => {
      this.loadUploader();
    })
  },
  computed: {
    isValid() {
      // Check errors count to determine valid or not
      return this.filesToUpload.length && this.errors.count() <= 0
    }
  },
  methods: {
    getPermission(){
      let that = this;
      const userPermissionsBasedOnEntity = that.loginUserInfo.db.userPermissionsBasedOnEntity;
      if(this.$route.meta && userPermissionsBasedOnEntity){
        that.permission.permissionBaseName = this.$route.meta.permissionBaseName;
        let userPermissionBasedOnEntity = userPermissionsBasedOnEntity.find(p => p.permissionBaseName === this.$route.meta.permissionBaseName);
        if(userPermissionBasedOnEntity){
          that.permission.permissionBaseNameCapabilities = userPermissionBasedOnEntity.capabilities;
          that.permission.permissionBaseNameCapabilities.forEach(capability=>{
            that.permission.capabilities[capability.label] = capability.value
          });
        } 
      } else{
        router.push('/no-permission-given');
      }
      console.log('permission: ' , that.permission);
    },
    routerBack(){
      this.$router.go(-1);
    },
    getEndPointBasedOnCustomerLocation(){
      let that = this;
      if(!that.loginUserInfo.db.company.customerLocation || that.loginUserInfo.db.company.customerLocation=='Global'){
        apigClient.invokeApi({}, '/settings/byKey/globalS3Endpoint', 'GET', {})
          .then(function(result){
            that.endPoint = result.data.data[0].settingValue;
          });
      }else if(that.loginUserInfo.db.company.customerLocation=='China'){
        apigClient.invokeApi({}, '/settings/byKey/chinaS3Endpoint', 'GET', {}, {})
          .then(function(result){
             that.endPoint = result.data.data[0].settingValue;
          });
      }
    },
    getMediaData: function(user_id) {
      var method = 'GET';
      var pathTemplate = '/media/' + this.media_id;
      var additionalParams ={};
      var pathParams = {};
      var userData = [];
      var self = this;
      self.isLoading = true;
      apigClient.invokeApi(pathParams, pathTemplate, method, additionalParams)
        .then(function(result){
          console.log("result data=",result["data"]["data"]);
          var mediaData = result["data"]["data"];
  
          var loadedFile = self.initilizeAddedFile({
              name:  mediaData.title,
              alias: mediaData.alias,
              description: (mediaData.description == 'NULL') ? '' : mediaData.description,
              published: mediaData.published,
              id: mediaData.id,
              preview_blob: mediaData.filepath,
              isVideo: (mediaData.mime.includes('image')) ? false : true,
            });
          self.filesToUpload.push(loadedFile);

          // Keep the current saved file info to compare in the future
          self.editModeCurrentSavedFile.fileS3Path = mediaData.filepath;
          self.editModeCurrentSavedFile.storage_location = mediaData.storage_location;
          self.editModeCurrentSavedFile.filename = mediaData.filename;
          self.editModeCurrentSavedFile.fileType = mediaData.mime;
          self.editModeCurrentSavedFile.fileSize = mediaData.size;
          self.editModeCurrentSavedFile.name = mediaData.title;
          self.editModeCurrentSavedFile.alias = mediaData.alias;
          self.editModeCurrentSavedFile.description = mediaData.description;
          self.editModeCurrentSavedFile.published = mediaData.published;
          self.editModeCurrentSavedFile.download_count = mediaData.download_count;
          self.editModeCurrentSavedFile.view_count = mediaData.view_count;

          console.log(self.editModeCurrentSavedFile);
    
          //This is where you would put a success callback
          self.isLoading = false;
        }).catch( function(error){
          console.log('ERROR ! Cannot get data:' + error);
          self.isLoading = false;
          //This is where you would put an error callback
        });
    },
    loadUploader: function(){
      // Import the plugins
      const Uppy = require('@uppy/core')
      const ThumbnailGenerator = require('@uppy/thumbnail-generator')
      const XHRUpload = require('@uppy/xhr-upload')
      const Dashboard = require('@uppy/dashboard')
      const GoogleDrive = require('@uppy/google-drive')
      const Dropbox = require('@uppy/dropbox')
      const Instagram = require('@uppy/instagram')
      const Tus = require('@uppy/tus')
      // And their styles (for UI plugins)
      require('@uppy/core/dist/style.css')
      require('@uppy/dashboard/dist/style.css')

      this.uppy = Uppy({
          autoProceed: false,
          debug: true,
          restrictions: {
            maxFileSize: 6000000,
            minNumberOfFiles: 1,
            maxNumberOfFiles: (this.isMediaEditMode) ? 1 : null,
            allowedFileTypes: ['image/*', 'video/*']
          },
        })
        .use(ThumbnailGenerator, {
          id: 'ThumbnailGenerator',
          thumbnailWidth: 200,
          thumbnailHeight: 200
        })
        .use(Dashboard, {
          target: this.$refs.selectfiles,
          inline: true,
          replaceTargetContent: true,
          showProgressDetails: true,
          note: 'Images and video only, up to 6 MB for each file',
          height: 350,
          width: 700,
          browserBackButtonClose: true
        })

        uppy.on('thumbnail:generated', (file, preview) => {
          // Add to filesToUpload array to appear image detail boxes if file id is not in the array
          if(this.isMediaEditMode){
            if(this.filesToUpload.length && (this.filesToUpload[0] != null || this.filesToUpload[0] != undefined)){
              // Edit Mode
              var fileToUpload = this.filesToUpload[0];
              fileToUpload.extension = file.extension;
              fileToUpload.preview_blob = preview;
              fileToUpload.data = file.data;
              fileToUpload.type = file.type;
              fileToUpload.size = file.size;

              this.fileDataToUpdate = file.data;
            }
          } else{
            // New Mode
            let i = this.filesToUpload.findIndex(f => f.id === file.id);
            if(i < 0){
              var fileToUpload = this.initilizeAddedFile({
                name:  file.name,
                extension: file.extension,
                id: file.id,
                preview_blob: preview,
                data: file.data,
                isVideo: false,
                type: file.type,
                size: file.size
              });
              
              this.filesToUpload.push(fileToUpload);
            }
          }

        })
        uppy.on('file-removed', (file) => {
          //console.log('Removed file', file)
          if(this.isMediaEditMode){
            if(this.filesToUpload.length && (this.filesToUpload[0] != null || this.filesToUpload[0] != undefined)){
              var fileToUpload = this.filesToUpload[0];
              fileToUpload.extension = '';
              fileToUpload.preview_blob = this.editModeCurrentSavedFile.fileS3Path;
              fileToUpload.isVideo = (this.editModeCurrentSavedFile.fileType.includes('image')) ? false : true;
              fileToUpload.data = null;
              fileToUpload.type = '';
              fileToUpload.size = 0;
              
              this.fileDataToUpdate = null;
            }
          } else{
            let removedFileIndex = this.filesToUpload.findIndex(f => f.id === file.id);
            if(removedFileIndex >= 0){
              this.filesToUpload.splice(removedFileIndex, 1);
            }
          }
        })
        uppy.on('file-added', (file) => {
           if(file.type.indexOf("video") >= 0 ){
             if(this.isMediaEditMode){
              if(this.filesToUpload.length && (this.filesToUpload[0] != null || this.filesToUpload[0] != undefined)){
                // Edit Mode
                var fileToUpload = this.filesToUpload[0];
                fileToUpload.extension = file.extension;
                fileToUpload.preview_blob = URL.createObjectURL(file.data);
                fileToUpload.isVideo = true;
                fileToUpload.data = file.data;
                fileToUpload.type = file.type;
                fileToUpload.size = file.size;

                this.fileDataToUpdate = file.data;
              }
             } else{
              var fileToUpload = this.initilizeAddedFile({
                name:  file.name,
                extension: file.extension,
                id: file.id,
                preview_blob: URL.createObjectURL(file.data),
                data: file.data,
                isVideo: true,
                type: file.type,
                size: file.size
              });
              
              this.filesToUpload.push(fileToUpload);
            }
           }
        })
    },
    initilizeAddedFile(file){
      var initializedFile = {};
      initializedFile['name']                 = this.setNullValue(file.name, '');
      initializedFile['extension']            = this.setNullValue(file.extension, '');
      initializedFile['alias']                = this.setNullValue(file.alias, '');
      initializedFile['description']          = this.setNullValue(file.description, '');
      initializedFile['published']            = this.setNullValue(file.published, true);
      initializedFile['id']                   = this.setNullValue(file.id, ''); file.id;
      initializedFile['preview_blob']         = this.setNullValue(file.preview_blob, null);
      initializedFile['data']                 = this.setNullValue(file.data, null);
      initializedFile['isVideo']              = this.setNullValue(file.isVideo, false);
      initializedFile['type']                 = this.setNullValue(file.type, '');
      initializedFile['size']                 = this.setNullValue(file.size, 0);
      initializedFile['storage_location']     = this.setNullValue(file.storage_location, '');
      initializedFile['filepath']             = this.setNullValue(file.filepath, '');
      initializedFile['filename']             = this.setNullValue(file.filename, '');
      initializedFile['fileNameAfterConcat']  = this.setNullValue(file.fileNameAfterConcat, '');
      initializedFile['onprogress']           = this.setNullValue(file.onprogress, false);
      initializedFile['success']              = this.setNullValue(file.success, false);
      initializedFile['successDetails']       = this.setNullValue(file.successDetails, '');
      initializedFile['error']                = this.setNullValue(file.error, false);
      initializedFile['errorDetails']         = this.setNullValue(file.errorDetails, '');
      initializedFile['presignedURLReceived'] = this.setNullValue(file.presignedURLReceived, false);
      initializedFile['uploadToS3Success']    = this.setNullValue(file.uploadToS3Success, false);
      initializedFile['saveToDBSuccess']      = this.setNullValue(file.saveToDBSuccess, false);

      return initializedFile;
    },
    setNullValue(fieldValue, nullValue){
      return (fieldValue != null && fieldValue != undefined) ? fieldValue : nullValue;
    },
    post:function(option){
      console.log(this.loginUserInfo.db.company.customerLocation);
      this.showProgress = true;
      if(this.isMediaEditMode){
        this.edit();
      }else{
        this.uploadAndSave();
      }
    },
    uploadClick:function(){
      this.showProgress = true;
      if(this.isMediaEditMode){
        this.edit();
      }else{
        this.uploadAndSave();
      }
    },
    onSubmit() {
      if (this.validate()) {
        this.$nextTick(() => {
          // submit
          this.submitted = true
          this.feedBack = 'info'
        })
      }
    },
    onReset() {
      this.submitted = false;
      this.showProgress = false
      this.showProgressVariant = 'info';
      this.showProgressAnimated = true;
      this.showProgressErrMsg = '';
      this.progressPercentage = 0
      this.progressMsg = ''
      this.selectfilepreivew = ''
      this.filesToUpload = []
      this.uppy.reset()
    },
    newMediaUpload(){
      router.push('/components/media/new');
    },

    // ToDO: Thant, Refactor edit() and uploadAndSave() to use common methods
    edit(){
      const axios = require('axios');
      var that = this;

      // Do the s3 upload if there is filed data added by uploader
      if(that.filesToUpload.length){
        let fileToUpload = that.filesToUpload[0];
        if(fileToUpload && fileToUpload.data != null){
          // Getting here means user already pick another media for update
          // Showing msg and progress bar
          that.progressMsg = "Getting Preserved URL to upload to S3";
          that.showProgressVariant = 'info';
          that.progressPercentage = 30;
          that.showProgressErrMsg = '';

          // Prepare array data to send to Lambda api to fetch s3 Presigned URL
          const loginUserInfo = JSON.parse(localStorage.getItem('loginUserInfo'));

          let companyName = (loginUserInfo.db.company.name == null || loginUserInfo.db.company.name == undefined || loginUserInfo.db.company.name == 'NULL') ? "ypb-group" : loginUserInfo.db.company.name.replace(/\s+/g, "-").toLowerCase();
          let filesToGetPresignedURL = {'bucketName': 'connect2resource',
                                        'subPath': 'companies' + '/' + companyName + '/' + 'media',
                                        'files': []} 
          var fileToGetPresignedURL = {};
          fileToGetPresignedURL['name'] = fileToUpload.name;
          fileToGetPresignedURL['extension'] = fileToUpload.extension;
          fileToGetPresignedURL['type'] = fileToUpload.type;
          fileToGetPresignedURL['id'] = fileToUpload.id;

          filesToGetPresignedURL.files.push(fileToGetPresignedURL);
          
          
          // Calling presigned url api
          var method = 'POST';
          var pathTemplate = '/s3/presignedurls';
          var additionalParams ={};
          var body = filesToGetPresignedURL;
          var pathParams = {};
            apigClient.invokeApi(pathParams, pathTemplate, method, additionalParams, body)
              .then(function(result){
                console.log(result.data);
                // * result getting the presignedUrls
                var filePresignedURLs = result.data;

                // Count of files that have presignUrl
                let countOfFilesThatHavePresignedURL = 0;
                filePresignedURLs.forEach(function(_fileP) {
                  if(_fileP.s3_presignedURL != null && _fileP.s3_presignedURL != undefined){
                    countOfFilesThatHavePresignedURL++;
                  }
                });

                // Update progress percentage & msg
                that.progressPercentage = 100;
                that.progressMsg = "Got " + countOfFilesThatHavePresignedURL + " S3 Preserved URL(s) ready";
                that.progressPercentage = 0;

                // * let's upload files to s3 directly in Vue side
                // Will loop the files list and only upload the file that got presigned url to s3 and save info to db.
                let index = 0;
                // Set some delay to show the msg uniquely
                setTimeout(()=>{
                  filePresignedURLs.forEach(async function(_filePresignURL) {
                    // Get the file to have full property
                    var file = that.filesToUpload.find(f => f.id === _filePresignURL.id);
                    if(file){
                      if(_filePresignURL.s3_presignedURL != null && _filePresignURL.s3_presignedURL != undefined){
                        // This file got s3_presignedURL && Let's Upload it to s3
                        file.onprogress = true; // show progress bar on file window right

                        index++;
                        file.presignedURLReceived = true;
                        // that.progressMsg = "Uploading " + index + "/" + countOfFilesThatHavePresignedURL;
                        that.progressMsg = "Uploading & Updating media file info...";
                        that.progressPercentage = 0;
                        that.progressPercentage = 30;

                        // Define axios options of file type and progress bar
                        const options = {
                          headers: {
                            "Content-Type": file.type
                          },
                        };

                        // upload file to s3 by axios
                        try{
                          const res = await axios.put(_filePresignURL.s3_presignedURL,file.data,options);
                          if(res && res.config.url){
                            
                            console.log(res.config.url);

                            // file is uploaded to s3 successfully and we got s3 file access url
                            file.uploadToS3Success = true;
                            // Concat s3 file access url and set path value with s3 url in the file item in array
                            var fileUrl = res.config.url;
                            var indexToRemove = fileUrl.indexOf('?');
                            fileUrl = fileUrl.substr(0, indexToRemove);
                            console.log('Concated File Path: ' + fileUrl);
                            file.filepath = fileUrl;
                            file.storage_location = 's3';
                            file.filename = _filePresignURL.filename;
                            file.fileNameAfterConcat = _filePresignURL.fileNameAfterConcat;
                          } else{
                            // upload file to s3 failed, will not save to db
                            file.onprogress = false;
                            file.uploadToS3Success = false;
                            file.saveToDBSuccess = false;
                            file.error = true;
                            file.errorDetails = '<template slot="title">Error Detials</template>'+
                                                '<span style="display:block">1. Get s3 Presigned URL : <strong>Success</strong></span>'+ 
                                                '<span style="display:block">2. Upload to S3 Storage : <strong>Failed</strong></span>'+
                                                '<span style="display:block"><strong>Error</strong>Something wrong with S3 Upload</span>' +
                                                '<span style="display:block">3. Update info to DB : <strong>Not Started</strong></span>' +
                                                '<span style="display:block">4. Delete old S3 file : <strong>Not Started</strong></span>';
                          }
                        } catch(error){
                          // upload file to s3 failed, will not save to db
                          file.onprogress = false;
                          file.uploadToS3Success = false;
                          file.saveToDBSuccess = false;
                          file.error = true;
                          file.errorDetails = '<template slot="title">Error Detials</template>'+
                                              '<span style="display:block">1. Get s3 Presigned URL : <strong>Success</strong></span>'+
                                              '<span style="display:block">2. Upload to S3 Storage : <strong>Failed</strong></span>'+
                                              '<span style="display:block"><strong>Error</strong>'+ error +'</span>' +
                                              '<span style="display:block">3. Update info to DB : <strong>Not Started</strong></span>' +
                                              '<span style="display:block">4. Delete old S3 file : <strong>Not Started</strong></span>';
                        }

                        // If s3 Upload success, will update the  media file info + delete old file at s3 to DB.
                        if(file.uploadToS3Success){
                          console.log('Upload file to S3: Success');
                          if(that.endPoint){
                            let filepathURL = new URL(file.filepath);
                            if(that.endPoint != filepathURL.origin){
                              file.filepath = file.filepath.replace(filepathURL.origin, that.endPoint);
                            }
                          }
                          // Trigger lambda api call to save media info
                          var method = 'PUT';
                          var pathTemplate = '/media/' + that.media_id;
                          var additionalParams ={};
                          var body = {
                              title: file.name,
                              alias: (file.alias == '') ? file.fileNameAfterConcat : file.alias ,
                              description: file.description,
                              published: file.published,
                              storage_location: that.editModeCurrentSavedFile.storage_location,
                              filepath: file.filepath,
                              oldPath: that.editModeCurrentSavedFile.fileS3Path,
                              filename: file.filename,
                              mime: file.type,
                              size: file.size,
                              download_count: that.editModeCurrentSavedFile.download_count,
                              view_count: that.editModeCurrentSavedFile.view_count,
                              updatedBy: that.loginUserInfo.login_username,
                              company_id: that.loginUserInfo.db.company.id,
                          };
                          var pathParams = {};
                          apigClient.invokeApi(pathParams, pathTemplate, method, additionalParams, body)
                            .then(function(result){
                              console.log(result);
                              var data = result["data"];
                              
                              if(data.db_update_success){
                                console.log('Updated the media, success: '+ result["data"]);
                                file.onprogress = false;
                                file.saveToDBSuccess = true;
                                file.success = true;
                                file.error = false;
                                file.successDetails = '<template slot="title">Success Detials</template>'+
                                                    '<span style="display:block">1. Get s3 Presigned URL : <strong>Success</strong></span>'+
                                                    '<span style="display:block">2. Upload to S3 Storage : <strong>Success</strong></span>'+
                                                    '<span style="display:block">3. Update info to DB : <strong>Success</strong></span>';
                                if(data.s3_delete_success){
                                  file.successDetails = file.successDetails + '<span style="display:block">4. Delete old S3 file : <strong>Success</strong></span>'
                                } else{
                                  file.successDetails = file.successDetails + '<span style="display:block">4. Delete old S3 file : <strong>Failed</strong></span>' +
                                                                              '<span style="display:block"><strong>Error</strong>'+ data.s3_delete_error +'</span>';
                                }
                              } else{
                                // Update Failed
                                file.onprogress = false;
                                file.saveToDBSuccess = false;
                                file.success = false;
                                file.error = true;
                                file.errorDetails = '<template slot="title">Error Detials</template>'+
                                                    '<span style="display:block">1. Get s3 Presigned URL : <strong>Success</strong></span>'+
                                                    '<span style="display:block">2. Upload to S3 Storage : <strong>Success</strong></span>'+
                                                    '<span style="display:block">3. Update info to DB : <strong>Failed</strong></span>'+
                                                    '<span style="display:block"><strong>Error</strong>'+ data.db_update_error.message +'</span>' +
                                                    '<span style="display:block">4. Delete old S3 file : <strong>Not started</strong></span>';
                              }
                              
                              
                            }).catch( function(result){
                              console.log(result);
                              file.onprogress = false;
                              file.saveToDBSuccess = false;
                              file.success = false;
                              file.error = true;
                              file.errorDetails = '<template slot="title">Error Detials</template>'+
                                                  '<span style="display:block">1. Get s3 Presigned URL : <strong>Success</strong></span>'+
                                                  '<span style="display:block">2. Upload to S3 Storage : <strong>Success</strong></span>'+
                                                  '<span style="display:block">3. Update info to DB : <strong>Failed</strong></span>'+
                                                  '<span style="display:block"><strong>Error</strong>'+ result +'</span>' + 
                                                  '<span style="display:block">4. Delete old S3 file : <strong>Not started</strong></span>'
                            });


                        }
                        //
                        if(index == countOfFilesThatHavePresignedURL){
                          let failedFileFound = false;
                          that.filesToUpload.forEach(function(_uploadFile) {
                            if(_uploadFile.error == true){
                              failedFileFound = true;
                            }
                          })
                          that.progressMsg = (failedFileFound) ? 
                                              "Upload & Updating Media Partially Completed! See File Upload Status in tick and cross of file window below."
                                              : "Upload & Updating Media Completed!"
                          that.progressPercentage = 100; 
                          that.showProgressAnimated = false;
                          that.submitted = true;
                        }

                      }else{
                        // This file didn't get s3_presignedURL, log the status and error in files array
                        file.onprogress = false;
                        file.presignedURLReceived = false;
                        file.error = true;
                        file.errorDetails = '<template slot="title">Error Detials</template>'+
                                            '<span style="display:block">1. Get s3 Presigned URL : <strong>Failed</strong></span>'
                                            '<span style="display:block"><strong>Error</strong>: ' + _filePresignURL.error_s3_presignedURL + '</span>' +
                                            '<span style="display:block">2. Upload to S3 Storage : <strong>Not Started</strong></span>'
                                            '<span style="display:block">3. Update info to DB : <strong>Not Started</strong></span>'
                      }
                    }
                  });
                },1000);   
              }).catch( function(result){
                console.log(result);
                // Failed Getting Presigned URLs, show error
                that.progressMsg = "Failed to Get Preserved URL to upload to S3. Upload to S3 Process terminated. Updating Media Info Progressing...";
                that.showProgressVariant = 'danger';
                that.showProgressErrMsg = JSON.stringify(result);
              });
        } else{
          that.showProgressVariant = 'info';
          that.progressPercentage = 30;
          that.showProgressErrMsg = '';
          // Getting here means user didn't pick other media for update
          // Will do the update media info only
          var file = fileToUpload;

          that.progressMsg = "Updating media file info...";
          // Set some delay to show the msg uniquely
          setTimeout(()=>{
            file.onprogress = true;

            that.progressPercentage = 0;
            that.progressPercentage = 40;

            // Trigger lambda api call to save media info
            var method = 'PUT';
            var pathTemplate = '/media/' + that.media_id;
            var additionalParams ={
            };
            var body = {
                title: file.name,
                alias: file.alias ,
                description: file.description,
                published: file.published,
                storage_location: that.editModeCurrentSavedFile.storage_location,
                filepath: that.editModeCurrentSavedFile.fileS3Path,
                oldPath: null,
                filename: that.editModeCurrentSavedFile.filename,
                mime: that.editModeCurrentSavedFile.fileType,
                size: that.editModeCurrentSavedFile.fileSize,
                download_count: that.editModeCurrentSavedFile.download_count,
                view_count: that.editModeCurrentSavedFile.view_count,
                updatedBy: that.loginUserInfo.login_username,
                company_id: that.loginUserInfo.db.company.id,
            };
            var pathParams = {
            };
            apigClient.invokeApi(pathParams, pathTemplate, method, additionalParams, body)
              .then(function(result){
                var data = result["data"];      
                if(data.db_update_success){
                  console.log('Updated the media, success: '+ result["data"]);
                  file.onprogress = false;
                  file.saveToDBSuccess = true;
                  file.success = true;
                  file.error = false;
                  file.successDetails = '<template slot="title">Success Detials</template>'+
                                        '<span style="display:block">Update info to DB : <strong>Success</strong></span>';

                  that.progressMsg = "Update Media Completed!"
                  that.progressPercentage = 100; 
                  that.showProgressAnimated = false;
                  that.submitted = true;
                } else{
                  // Update Failed
                  file.onprogress = false;
                  file.saveToDBSuccess = false;
                  file.success = false;
                  file.error = true;
                  file.errorDetails = '<template slot="title">Error Detials</template>'+
                                      '<span style="display:block">Update info to DB : <strong>Failed</strong></span>'+
                                      '<span style="display:block"><strong>Error</strong>'+ data.db_update_error.message +'</span>';
                  that.progressMsg = "Update Media Failed!"
                  that.showProgressVariant = 'danger';
                  that.showProgressAnimated = false;
                  that.showProgressErrMsg = data.db_update_error;
                }
                
                
              }).catch( function(result){
                console.log(result);
                file.onprogress = false;
                file.saveToDBSuccess = false;
                file.success = false;
                file.error = true;
                file.errorDetails = '<template slot="title">Error Detials</template>'+
                                    '<span style="display:block">Update info to DB : <strong>Failed</strong></span>'+
                                    '<span style="display:block"><strong>Error</strong>'+ result +'</span>';

                that.progressMsg = "Update Media Failed!"
                that.showProgressVariant = 'danger';
                that.showProgressAnimated = false;
                that.showProgressErrMsg = JSON.stringify(result);                     
            });   
          },1000); 
        }
      }
    },
    uploadAndSave(){
      const axios = require('axios')
      // 1. Get Presigned URL from s3 First (API call)
      // 2. Upload the files with presigned URL to s3 directly (Vue)
      // 3. Save to db (API Call)
      var that = this; 

      // Showing msg and progress bar
      that.progressMsg = "Getting Preserved URLs to upload to S3";
      that.showProgressVariant = 'info';
      that.progressPercentage = 30;
      that.showProgressErrMsg = '';

      // Prepare array data to send to Lambda api to fetch s3 Presigned URL
      const loginUserInfo = JSON.parse(localStorage.getItem('loginUserInfo'));

      let companyName = (loginUserInfo.db.company.name == null || loginUserInfo.db.company.name == undefined || loginUserInfo.db.company.name == 'NULL') ? "ypb-group" : loginUserInfo.db.company.name.replace(/\s+/g, "-").toLowerCase();
      let filesToGetPresignedURL = {'bucketName': 'connect2resource',
                                    'subPath': 'companies' + '/' + companyName + '/' + 'media',
                                    'files': []} 
            
      this.filesToUpload.forEach(function(_file) {
        var fileToGetPresignedURL = {};
        fileToGetPresignedURL['name'] = _file.name;
        fileToGetPresignedURL['extension'] = _file.extension;
        fileToGetPresignedURL['type'] = _file.type;
        fileToGetPresignedURL['id'] = _file.id;

        filesToGetPresignedURL.files.push(fileToGetPresignedURL);
      })
      
      // Calling presigned url api
      var method = 'POST';
      var pathTemplate = '/s3/presignedurls';
      var additionalParams ={};
      var body = filesToGetPresignedURL;
      var pathParams = {};
      apigClient.invokeApi(pathParams, pathTemplate, method, additionalParams, body)
        .then(function(result){
          console.log(result.data);
          // * result getting the presignedUrls
          var filePresignedURLs = result.data;

          // Count of files that have presignUrl
          let countOfFilesThatHavePresignedURL = 0;
          filePresignedURLs.forEach(function(_fileP) {
            if(_fileP.s3_presignedURL != null && _fileP.s3_presignedURL != undefined){
              countOfFilesThatHavePresignedURL++;
            }
          });

          // Update progress percentage & msg
          that.progressPercentage = 100;
          that.progressMsg = "Got " + countOfFilesThatHavePresignedURL + " S3 Preserved URL(s) ready";
          that.progressPercentage = 0;

          // * let's upload files to s3 directly in Vue side
          // Will loop the files list and only upload the file that got presigned url to s3 and save info to db.
          let index = 0;
          // Set some delay to show the msg uniquely
          setTimeout(()=>{
            filePresignedURLs.forEach(async function(_filePresignURL) {
              // Get the file to have full property
              var file = that.filesToUpload.find(f => f.id === _filePresignURL.id);
              
              if(file){
                if(_filePresignURL.s3_presignedURL != null && _filePresignURL.s3_presignedURL != undefined){
                  // This file got s3_presignedURL && Let's Upload it to s3
                  file.onprogress = true; // show progress bar on file window right

                  index++;
                  file.presignedURLReceived = true;
                  // that.progressMsg = "Uploading " + index + "/" + countOfFilesThatHavePresignedURL;
                  that.progressMsg = "Uploading & Recording media file(s) info...";
                  that.progressPercentage = 0;

                  // Define axios options of file type and progress bar
                  const options = {
                    headers: {
                      "Content-Type": file.type
                    },
                  };

                  // upload file to s3 by axios
                  try{
                    //Exception thrown For testing
                    // if(index==2){
                    //     throw 500;
                    // }
                    const res = await axios.put(_filePresignURL.s3_presignedURL,file.data,options);
                    if(res && res.config.url){
                      console.log(res.config.url);
                      // file is uploaded to s3 successfully and we got s3 file access url
                      file.uploadToS3Success = true;

                      // Concat s3 file access url and set path value with s3 url in the file item in array
                      var fileUrl = res.config.url;
                      var indexToRemove = fileUrl.indexOf('?');
                      fileUrl = fileUrl.substr(0, indexToRemove);
                      console.log('Concated File Path: ' + fileUrl);
                      file.filepath = fileUrl;
                      file.storage_location = 's3';
                      file.filename = _filePresignURL.filename;
                      file.fileNameAfterConcat = _filePresignURL.fileNameAfterConcat;
                    } else{
                      file.onprogress = false;
                      // upload file to s3 failed, will not save to db
                      file.uploadToS3Success = false;
                      file.saveToDBSuccess = false;
                      file.error = true;
                      file.errorDetails = '<template slot="title">Error Detials</template>'+
                                          '<span style="display:block">1. Get s3 Presigned URL : <strong>Success</strong></span>'+ 
                                          '<span style="display:block">2. Upload to S3 Storage : <strong>Failed</strong></span>'+
                                          '<span style="display:block"><strong>Error</strong>Something wrong with S3 Upload</span>' +
                                          '<span style="display:block">3. Record info to DB : <strong>Not Started</strong></span>'
                    }
                  } catch(error){
                    file.onprogress = false;
                    // upload file to s3 failed, will not save to db
                    file.uploadToS3Success = false;
                    file.saveToDBSuccess = false;
                    file.error = true;
                    file.errorDetails = '<template slot="title">Error Detials</template>'+
                                        '<span style="display:block">1. Get s3 Presigned URL : <strong>Success</strong></span>'+
                                        '<span style="display:block">2. Upload to S3 Storage : <strong>Failed</strong></span>'+
                                        '<span style="display:block"><strong>Error</strong>'+ error +'</span>' +
                                        '<span style="display:block">3. Record info to DB : <strong>Not Started</strong></span>'
                  }

                  // If s3 Upload success, will record the file info to DB.
                  if(file.uploadToS3Success){
                    console.log(that.endPoint)
                    console.log('Upload file to S3: Success');
                    // Trigger lambda api call to save media info
                    if(that.endPoint){
                      let filepathURL = new URL(file.filepath);
                      if(that.endPoint != filepathURL.origin){
                        file.filepath = file.filepath.replace(filepathURL.origin, that.endPoint);
                      }
                    }
                    var method = 'POST';
                    var pathTemplate = '/media';
                    var additionalParams ={
                    };
                    var body = {
                        title: file.name,
                        alias: (file.alias == '') ? file.fileNameAfterConcat : file.alias ,
                        description: file.description ,
                        published: file.published,
                        storage_location: file.storage_location,
                        filepath: file.filepath,
                        filename: file.filename,
                        mime: file.type,
                        size: file.size,
                        createdBy: that.loginUserInfo.login_username,
                        company_id: that.loginUserInfo.db.company.id,
                    };
                    var pathParams = {
                    };

                    //that.progressMsg = "Recording media info " + index + "/" + countOfFilesThatHavePresignedURL;
                    //that.progressPercentage = 0;
                    apigClient.invokeApi(pathParams, pathTemplate, method, additionalParams, body)
                      .then(function(result){
                        console.log(result);
                        console.log('Created a new media, mediaId: '+ result["data"]["data"]);
                        
                        file.onprogress = false;
                        file.saveToDBSuccess = true;
                        file.success = true;
                        file.error = false;
                        file.successDetails = '<template slot="title">Success Detials</template>'+
                                            '<span style="display:block">1. Get s3 Presigned URL : <strong>Success</strong></span>'+
                                            '<span style="display:block">2. Upload to S3 Storage : <strong>Success</strong></span>'+
                                            '<span style="display:block">3. Record info to DB : <strong>Success</strong></span>';
                        
                      }).catch( function(result){
                        console.log(result);
                        file.onprogress = false;
                        file.saveToDBSuccess = false;
                        file.success = false;
                        file.error = true;
                        file.errorDetails = '<template slot="title">Error Detials</template>'+
                                            '<span style="display:block">1. Get s3 Presigned URL : <strong>Success</strong></span>'+
                                            '<span style="display:block">2. Upload to S3 Storage : <strong>Success</strong></span>'+
                                            '<span style="display:block">3. Record info to DB : <strong>Failed</strong></span>'+
                                            '<span style="display:block"><strong>Error</strong>'+ result +'</span>'
                      });


                  }
                  //
                  if(index == countOfFilesThatHavePresignedURL){
                    let failedFileFound = false;
                    that.filesToUpload.forEach(function(_uploadFile) {
                      if(_uploadFile.error == true){
                        failedFileFound = true;
                      }
                    })
                    that.progressMsg = (failedFileFound) ? 
                                        "Upload & Recording Media(s) Partially Completed! See File Upload Status in tick and cross of each file below."
                                        : "Upload & Recording Media(s) Completed!"
                    that.progressPercentage = 100; 
                    that.showProgressAnimated = false;
                    that.submitted = true;
                  }

                }else{
                  // This file didn't get s3_presignedURL, log the status and error in files array
                  file.onprogress = false;
                  file.presignedURLReceived = false;
                  file.error = true;
                  file.errorDetails = '<template slot="title">Error Detials</template>'+
                                      '<span style="display:block">1. Get s3 Presigned URL : <strong>Failed</strong></span>'
                                      '<span style="display:block"><strong>Error</strong>: ' + _filePresignURL.error_s3_presignedURL + '</span>' +
                                      '<span style="display:block">2. Upload to S3 Storage : <strong>Not Started</strong></span>'
                                      '<span style="display:block">3. Record info to DB : <strong>Not Started</strong></span>'
                }
              }
            });
          },1000);                   
        }).catch( function(result){
          console.log(result);
          // Failed Getting Presigned URLs, show error
          that.progressMsg = "Failed to Get Preserved URLs to upload to S3. Process terminated.";
          that.showProgressVariant = 'danger';
          that.showProgressAnimated = false;
          that.showProgressErrMsg = result;
        });
    },
  },
  notifications: {
    showSuccessMsg: {
      type: VueNotifications.types.success,
      title: 'Operation successfull!',
      message: 'The media libraries have been created'
    },
    showInfoMsg: {
      type: VueNotifications.types.info,
      title: 'Info',
      message: 'Here is some info for you'
    },
    showWarnMsg: {
      type: VueNotifications.types.warn,
      title: 'Warning',
      message: 'That\'s the kind of warning'
    },
    showErrorMsg: {
      type: VueNotifications.types.error,
      title: 'ERROR',
      message: 'The media library cannot be saved'
    }
  },
}
</script>
<style scoped>
  .uppy-Dashboard-progressindicators{
    display: none;
  }
  .selectVideoPreivew{
    width: auto;
    max-height: 240px;
    z-index: 1 !important;
    position: absolute;
    display:block;
    margin:auto;
  }
  .selectFilePreivew{
    max-height: 220px;
    max-width: 100%;
    position: absolute;
    display:block;
    margin:auto;
  }
  .btn.disabled {
    cursor: auto;
  }
  .custom-header{
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .btn-group > .btn, .btn-group-vertical > .btn {
      border: 1px solid #a4acb5;
  }

  @media only screen and (max-width: 600px) {
    .custom-header{
      flex-direction: column;
      align-items: inherit;
    }

    .custom-header > div:first-child {
      margin-bottom: 10px;
    } 

  }
  .custom-cancel {
    border-radius: 0.25rem 0 0 0.25rem;
  }
  .sk-fading-circle .sk-circle {
    margin: 0 auto;
  }
  .sk-three-bounce {
    height: 40px;
  }

</style>

<style>
  #language {
    margin-top: 15px;
  }
  .custom-header{
    display: flex;
    justify-content: space-between;
  } 
  select {
    /* for Firefox */
    -moz-appearance: none;
    /* for Chrome */
    -webkit-appearance: none;
  }
  /* For IE10 */
  select::-ms-expand {
    display: none;
  }

  .width-50px{
    width: 50px;
  }

  .uploadBtn{
    display:block;
    font-size: 14px;
    padding: 13px 22px;
    width: auto;
    color: #fff;
    background-color: #1bb240;
    line-height: 1;
    margin-bottom: 30px;
  }

  .uppy-Dashboard-progressindicators {
    display: none;
  }
  
</style>